import { Controller as BaseController } from '@hotwired/stimulus';

export default class Controller extends BaseController {
  connect() {}

  handle_dismiss() {
    $('.details').addClass(`d-none`);
  }
}
